import { useOrganisationFilterStore } from '@/stores/organisation-filter-store'

export function useOrganisationFilter(): { organisation_id?: number[] } {
  const selectedIds = useOrganisationFilterStore((s) => s.selectedOrganisationIds)
  return selectedIds.length > 0 ? { organisation_id: selectedIds } : {}
}
